var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.dataForm ? _c("div", [_c("a-form-model", {
    attrs: {
      "label-col": {
        span: 4
      },
      "wrapper-col": {
        span: 20
      }
    }
  }, [_c("top-title", [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t("方案信息")))])]), _c("a-row", {
    staticStyle: {
      display: "flex",
      "flex-wrap": "wrap"
    }
  }, [_c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("方案名称")
    }
  }, [_c("a-input", {
    attrs: {
      value: _vm.dataForm.name || "-",
      readOnly: true
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("方案代码")
    }
  }, [_c("a-input", {
    attrs: {
      value: _vm.dataForm.code || "-",
      readOnly: true
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    staticClass: "cont",
    attrs: {
      label: _vm.$t("保费")
    }
  }, [_vm.dataForm.priceType != "AREA_PRICE" ? _c("a-input", {
    staticStyle: {
      width: "70%"
    },
    attrs: {
      value: _vm.dataForm.price || "-",
      readOnly: true
    }
  }) : _vm._e(), _vm.dataForm.priceType == "AREA_PRICE" ? _c("a-input", {
    staticStyle: {
      width: "70%"
    },
    attrs: {
      value: _vm.dataForm.price.split(",")[0] || "-",
      readOnly: true
    }
  }) : _vm._e(), _vm.dataForm.priceType == "AREA_PRICE" ? _c("span", {
    staticStyle: {
      margin: "0 5px"
    }
  }, [_vm._v("~")]) : _vm._e(), _vm.dataForm.priceType == "AREA_PRICE" ? _c("a-input", {
    staticStyle: {
      width: "70%"
    },
    attrs: {
      value: _vm.dataForm.price.split(",")[1] || "-",
      readOnly: true
    }
  }) : _vm._e(), _c("span", {
    staticStyle: {
      display: "flex",
      width: "30px",
      margin: "0 5px",
      "flex-shrink": "0"
    }
  }, [_vm._v(_vm._s(_vm.$t(_vm.i18nCurrencyUnit(_vm.$store.state.user.accountInfo.customerId, false))))])], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    staticClass: "cont",
    attrs: {
      label: _vm.$t("保障金额")
    }
  }, [_c("a-input", {
    staticStyle: {
      width: "72%"
    },
    attrs: {
      value: _vm.dataForm.amount || "-",
      readOnly: true
    }
  }), _c("span", {
    staticStyle: {
      margin: "0 5px"
    }
  }, [_vm._v(_vm._s(_vm.$t(_vm.i18nCurrencyUnit(_vm.$store.state.user.accountInfo.customerId, false))))])], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("缴费期限")
    }
  }, [_c("a-input", {
    attrs: {
      value: _vm.$t(_vm.dataForm.paymentDeadlineName) || "-",
      readOnly: true
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("保障年龄")
    }
  }, [_c("a-input", {
    attrs: {
      value: _vm.dataForm.ageName.replace("周岁", _vm.$t("周岁")).replace("岁", _vm.$t("岁")).replace("月", _vm.$t("月")).replace("天", _vm.$t("天")) || "-",
      readOnly: true
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("职业类别")
    }
  }, [_c("a-input", {
    attrs: {
      value: _vm.dataForm.occupation || "-",
      readOnly: true
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("保障期限")
    }
  }, [_c("a-input", {
    attrs: {
      value: _vm.$t(_vm.dataForm.durationName.replace("年", _vm.$t("年")).replace("天", _vm.$t("天"))) || "-",
      readOnly: true
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("性别")
    }
  }, [_c("a-input", {
    attrs: {
      value: _vm.dataForm.sex == 0 ? _vm.$t("无限制") : _vm.dataForm.sex == 1 ? _vm.$t("男") : _vm.$t("女"),
      readOnly: true
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("社保")
    }
  }, [_c("a-input", {
    attrs: {
      value: _vm.dataForm.socialSecurity == 0 ? _vm.$t("无限制") : _vm.dataForm.sex == 1 ? _vm.$t("有") : _vm.$t("无"),
      readOnly: true
    }
  })], 1)], 1), _vm.dataForm.wait ? _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    staticClass: "cont",
    attrs: {
      label: _vm.$t("等待期")
    }
  }, [_c("a-input", {
    staticStyle: {
      "margin-right": "10px",
      width: "80px"
    },
    attrs: {
      value: _vm.dataForm.wait.type == 1 ? _vm.$t("自然日") : _vm.$t("工作日"),
      readOnly: true
    }
  }), _c("a-input", {
    attrs: {
      value: _vm.dataForm.wait.value || "-",
      readOnly: true
    }
  })], 1)], 1) : _vm._e(), _vm.dataForm.hesitate ? _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    staticClass: "cont",
    attrs: {
      label: _vm.$t("犹豫期")
    }
  }, [_c("a-input", {
    staticStyle: {
      "margin-right": "10px",
      width: "80px"
    },
    attrs: {
      value: _vm.dataForm.hesitate.type == 1 ? _vm.$t("自然日") : _vm.$t("工作日"),
      readOnly: true
    }
  }), _c("a-input", {
    attrs: {
      value: _vm.dataForm.hesitate.value || "-",
      readOnly: true
    }
  })], 1)], 1) : _vm._e(), _c("a-col", {
    attrs: {
      span: 24
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("方案备注"),
      labelCol: {
        span: 2,
        offset: 0
      },
      "wrapper-col": {
        span: 22,
        offset: 0
      }
    }
  }, [_c("a-input", {
    attrs: {
      value: _vm.dataForm.remark || "-",
      readOnly: true
    }
  })], 1)], 1), _vm.dataForm.tagsData.length != 0 ? _c("a-col", {
    attrs: {
      span: 24
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("方案标签"),
      labelCol: {
        span: 2,
        offset: 0
      },
      "wrapper-col": {
        span: 22,
        offset: 0
      }
    }
  }, _vm._l(_vm.dataForm.tagsData, function (tag) {
    return _c("a-tag", {
      key: tag.id,
      attrs: {
        color: "blue"
      }
    }, [_vm._v(_vm._s(tag.fieldKey) + "/" + _vm._s(tag.fieldValue))]);
  }), 1)], 1) : _vm._e()], 1), _vm.dataForm.area.length != 0 ? _c("top-title", [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t("保费模版")))])]) : _vm._e(), _vm.dataForm.area.length != 0 ? _c("a-row", [_c("a-col", {
    attrs: {
      span: 24
    }
  }, [_c("a-form-model-item", {
    attrs: {
      "wrapper-col": {
        span: 18,
        offset: 2
      }
    }
  }, [_c("a-table", {
    staticClass: "marginT20",
    attrs: {
      bordered: "",
      columns: _vm.PREMIUMPLANCOLUMNS,
      "data-source": _vm.dataForm.area,
      pagination: false,
      rowKey: "index"
    }
  }, [_vm._l(_vm.PREMIUMPLANCOLUMNS, function (item, i) {
    return _c("span", {
      key: i,
      attrs: {
        slot: item.slots.title
      },
      slot: item.slots.title
    }, [_vm._v(_vm._s(_vm.$t(item.slots.title)))]);
  }), _c("template", {
    slot: "保费"
  }, [_vm._v(" (" + _vm._s(_vm.$t(_vm.i18nCurrencyUnit(_vm.$store.state.user.accountInfo.customerId, false))) + ") ")])], 2)], 1)], 1)], 1) : _vm._e(), _vm.dataForm.rights.length != 0 ? _c("top-title", [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t("保障权益")))])]) : _vm._e(), _vm.dataForm.rights.length != 0 ? _c("a-row", [_c("a-col", {
    attrs: {
      span: 24
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("保障权益"),
      labelCol: {
        span: 2,
        offset: 0
      },
      "wrapper-col": {
        span: 22,
        offset: 0
      }
    }
  }, _vm._l(_vm.dataForm.rights, function (item, index) {
    return _c("div", {
      key: index,
      staticClass: "cont",
      style: index != 0 ? "margin-top:10px" : ""
    }, [_c("a-input", {
      staticStyle: {
        width: "300px"
      },
      attrs: {
        placeholder: _vm.$t("保障权益"),
        readOnly: true
      },
      model: {
        value: item.name,
        callback: function ($$v) {
          _vm.$set(item, "name", $$v);
        },
        expression: "item.name"
      }
    }), _c("a-input", {
      staticStyle: {
        "margin-left": "20px",
        width: "200px"
      },
      attrs: {
        placeholder: _vm.$t("保障金额"),
        readOnly: true
      },
      model: {
        value: item.value,
        callback: function ($$v) {
          _vm.$set(item, "value", $$v);
        },
        expression: "item.value"
      }
    }), _c("a-input", {
      staticStyle: {
        "margin-left": "20px"
      },
      attrs: {
        readOnly: true
      },
      model: {
        value: item.info,
        callback: function ($$v) {
          _vm.$set(item, "info", $$v);
        },
        expression: "item.info"
      }
    })], 1);
  }), 0)], 1)], 1) : _vm._e(), _vm.dataForm.attachInfo.length != 0 ? _c("top-title", [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t("附加险")))])]) : _vm._e(), _vm.dataForm.attachInfo.length != 0 ? _c("a-row", [_c("a-col", {
    attrs: {
      span: 24
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("附加险"),
      labelCol: {
        span: 2,
        offset: 0
      },
      "wrapper-col": {
        span: 18,
        offset: 0
      }
    }
  }, [_c("a-table", {
    attrs: {
      bordered: "",
      columns: _vm.ADDITIONALCOLUMNS,
      "data-source": _vm.dataForm.attachInfo,
      pagination: false,
      rowKey: "attachId"
    }
  }, _vm._l(_vm.ADDITIONALCOLUMNS, function (item, i) {
    return _c("span", {
      key: i,
      attrs: {
        slot: item.slots.title
      },
      slot: item.slots.title
    }, [_vm._v(_vm._s(_vm.$t(item.slots.title)))]);
  }), 0)], 1)], 1)], 1) : _vm._e(), _vm.dataForm.termsList.length != 0 ? _c("top-title", [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t("方案条款")))])]) : _vm._e(), _vm.dataForm.termsList.length != 0 ? _c("a-row", [_c("a-col", {
    attrs: {
      span: 24
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("方案条款"),
      labelCol: {
        span: 2,
        offset: 0
      },
      "wrapper-col": {
        span: 18,
        offset: 0
      }
    }
  }, [_c("a-table", {
    attrs: {
      bordered: "",
      columns: _vm.TERMSCOLUMNS,
      "data-source": _vm.dataForm.termsList,
      pagination: false,
      rowKey: "id"
    },
    scopedSlots: _vm._u([{
      key: "operation",
      fn: function (_, record) {
        return [_c("a-button", {
          staticStyle: {
            "margin-right": "20px"
          },
          attrs: {
            size: "small",
            type: "edit"
          },
          on: {
            click: function ($event) {
              return _vm.onPreview(record);
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("预览")))]), _c("a-button", {
          attrs: {
            size: "small",
            type: "copy"
          },
          on: {
            click: function ($event) {
              return _vm.onDownload(record);
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("下载")))])];
      }
    }], null, false, 2427238015)
  }, _vm._l(_vm.TERMSCOLUMNS, function (item, i) {
    return _c("span", {
      key: i,
      attrs: {
        slot: item.slots.title
      },
      slot: item.slots.title
    }, [_vm._v(_vm._s(_vm.$t(item.slots.title)))]);
  }), 0)], 1)], 1)], 1) : _vm._e(), _vm.dataForm.healthNotice ? _c("top-title", [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t("健康告知")))])]) : _vm._e(), _vm.dataForm.healthNotice ? _c("a-row", [_c("a-col", {
    attrs: {
      span: 24
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("文本内容"),
      labelCol: {
        span: 2,
        offset: 0
      },
      "wrapper-col": {
        span: 22,
        offset: 0
      }
    }
  }, [_c("div", {
    staticClass: "healthNotice",
    domProps: {
      innerHTML: _vm._s(_vm.dataForm.healthNotice)
    }
  })])], 1)], 1) : _vm._e()], 1)], 1) : _vm._e();
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };